import * as formik from 'formik';
import * as fabric from 'office-ui-fabric-react';
import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import * as api from '../../../../../api/generated';
import { KendoLoading } from '../../../../../components';
import { ISettings } from '../GeneralSettingsPage';

interface IProps {
    settings: ISettings | null;
    fetchData: Function;
}
const validationSchema = Yup.object<ISettings>().shape({
    terminalsAdminKey: Yup.number()
        .required('Šis laukas yra privalomas')
        .test('len', 'Slaptažodį privalo sudaryti 4-11 skaitmenų', (val) => val.toString().length >= 4 && val.toString().length <= 11)
        .positive('Skaičius privalo būti teigiamas')
});

const GeneralSettingsTerminalsAdministration: FC<IProps> = (props) => {
    const { organizationId } = useParams<'organizationId'>();

    const handleSubmit = async (values: ISettings, formikActions: formik.FormikHelpers<ISettings>) => {
        formikActions.setStatus();
        try {
            await api.administration.updateOranizationTerminalsAdministration({ id: parseInt(organizationId.toString()), ...values });
            toast.success('Nustatymai sėkmingai išsaugoti');
        } catch (ex) {
            formikActions.setStatus(ex);
            toast.error(ex.error[0]);
        } finally {
            formikActions.setSubmitting(false);
            formikActions.resetForm();
            props.fetchData();
        }
    };

    return (
        <div className="ms-Grid" dir="ltr">
            {!props.settings && <KendoLoading />}
            {props.settings && (
                <formik.Formik
                    validationSchema={validationSchema}
                    initialValues={{ ...props.settings }}
                    onSubmit={handleSubmit}
                    render={(formikProps) => (
                        <formik.Form>
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg6">
                                    <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg6">
                                        <formik.Field
                                            name="terminalsAdminKey"
                                            render={({ field, form }: formik.FieldProps<string>) => (
                                                <fabric.TextField
                                                    onChange={({}, value: any) => form.setFieldValue('terminalsAdminKey', value)}
                                                    defaultValue={field.value}
                                                    label="Administravimo lango slaptažodis"
                                                    placeholder="789456123"
                                                    type="number"
                                                    errorMessage={
                                                        (formikProps.status && formikProps.status.terminalsAdminKey) || form.errors.terminalsAdminKey
                                                    }
                                                />
                                            )}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="ms-Grid-row">
                                <div style={{ textAlign: 'center', marginTop: '30px' }}>
                                    <fabric.PrimaryButton
                                        className="ms-slideRightIn40 ms-textAlignRight"
                                        text="Išsaugoti"
                                        disabled={formikProps.isSubmitting || !formikProps.isValid || !formikProps.dirty}
                                        type="submit"
                                    />
                                </div>
                            </div>
                        </formik.Form>
                    )}
                />
            )}
        </div>
    );
};

export default GeneralSettingsTerminalsAdministration;
